import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import { useTranslation } from "react-i18next";

const Footer = () => {
    const { t } = useTranslation();

    return <footer className="rev-footer">
        <a href="https://revopic.com" target="_blank" rel="noopener noreferrer">© Revopic {new Date().getFullYear()}</a>
        <div className="rev-footer__links">
            <a href="https://revopic.com/terms-and-conditions/" target="_blank" rel="noopener noreferrer">{t('Terms of Use')}</a>
            <span>|</span>
            <a href="https://revopic.com/privacy-policy/" target="_blank" rel="noopener noreferrer">{t('Privacy Policy')}</a>
        </div>
    </footer>
};

const mapStateToProps = state => (
    {
        user: state.usersReducer.user
    }
);

export default withRouter(connect(mapStateToProps, null)(Footer));
